// Import necessary modules and hooks from React Router and React
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";

// Define a component called PublicRoute which receives a prop called redirectPath with a default value of '/home'
export const PublicRoute = ({ redirectPath = '/videowall' }) => {
    // Use the useAuthContext() hook to get the user from the authentication context
    const { user, zones } = useAuthContext();

    const [token, setToken] = useState(null);

    // Define an effect that updates the token state when the user changes
    useEffect(() => {
        setToken(localStorage.getItem('unified_videowall_cascais_token'));
    }, [user]); // Dependency of the effect, this effect will be triggered when the user changes

    // If there is a token, log the redirection path and navigate to the specified route
    if (user && token) {
        return <Navigate to={redirectPath} replace />;
    }

    // If there's no token, render the Outlet component which renders nested routes
    return <Outlet />
};